import { render, staticRenderFns } from "./ClosedCashRegister.vue?vue&type=template&id=1b595264"
import script from "./ClosedCashRegister.vue?vue&type=script&lang=js"
export * from "./ClosedCashRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports